import * as React from 'react';
import { UserState } from '../../../interface/MyInterfaces';
import { VendorReportState2025, VendorProfile, VendorReportAction2025 } from '../../../interface/VendorReportInterface2025';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';
import NewVendorTab1First2025 from './NewVendorTab1First2025';
import { buildTitleText } from '../../../actions/VendorReportActions2025';

interface VendorProfileState {
    selectedVendorProfile?: VendorProfile;
}

class NewVendorProfilesTab2025 extends React.Component<VendorReportState2025 & UserState & VendorReportAction2025, VendorProfileState> {

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.VendorProfile !== undefined) {
            this.setState({
                selectedVendorProfile: nextProps.VendorProfile[0],
            });
        }
    }
    componentDidMount() {
        if (this.props.VendorProfile) {
            this.setState({ selectedVendorProfile: this.props.VendorProfile[0] });
        }
    }

    render() {
        let logoUni;
        //when report is shared the inital report display id is undefined which blocks the report from loading

        if (this.props.display_id) {
            try {
                logoUni = require(`../../../images/univ_logos/${this.props.display_id}.png`);
            }
            catch (err) {

            }
        }
        return <div className='firstTab tabcontents container-fluid vendor-report-content'>
            <div className='row'>
                <div className="col-md-12">
                    <div className="bullets--before">
                        <div className="newVendorTitleDiv">
                            <h1>{buildTitleText(this.props.agg, this.props.HomeState?.campusname)}</h1>
                            <div className="universityLogo">
                                {logoUni &&
                                    <img height='60px'
                                        src={String(logoUni)}
                                        alt='Logo'></img>
                                }
                            </div>
                        </div>
                        {this.props.display_id == "99007319" && <div>
                            <h2><b style={{ color: "red" }}>Synthetic data for demonstration purposes only</b></h2>
                        </div>}
                        <p>
                            {this.props.HomeState && this.props.HomeState.campusname == "CPUPC/IRIS Universities" && "CPUPC comprises Texas public general academic universities, system offices, health-related institutions, and the three two-year state colleges in the Houston area. "}
                            {this.props.ReportsConf && this.props.ReportsConf.methodology_text}
                        </p>
                    </div>
                </div>
            </div>
            <NewVendorTab1First2025
                sliderChange={this.props.sliderChange}
                display_id={this.props.display_id}
                selected_year={this.props.selected_year}
                university={this.props.HomeState && this.props.HomeState.campusname}
                HomeState={this.props.HomeState}
                VendorProfilesByYear={this.props.VendorProfilesByYear}
                BVDMatchRates={this.props.BVDMatchRates}
                minYear={this.props.TrendsPar ? this.props.TrendsPar[0].min_year : 0}
                maxYear={this.props.TrendsPar ? this.props.TrendsPar[0].max_year : 0}
                VendorReport_Tab12025={this.props.VendorReport_Tab12025}
                vendorRelease={this.props.vendorRelease}
                agg={this.props.agg}
                institutionName={this.props.institutionName}
            />
        </div>;
    }
}

export default withUserActionTracker(NewVendorProfilesTab2025, "Vendor Profile Report", "viewed Vendor Profiles Tab");